import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

// reserved / import config from '../config';
import { useQuery } from '../hooks/graph';
// reserved / import { SetupContext } from '../contexts/setup';

const controller = new AbortController();

function MeReport({ match }) {
	// const { providerName: selectedProviderName } = match.params || {};
	// const { providers } = useContext(SetupContext);
	const [ { data: dataConnectors } ] = useQuery('connectors', controller);
	const [ { data } ] = useQuery('hooks', controller);

	useEffect(() => () => controller.abort(), []); // abort on unmount

	return data && dataConnectors && (
		<div id="report">
			<h3 className="my-3">Reporting?</h3>

			<div className="mb-4 p-2 p-lg-3 bg-light rounded rounded-3">
				In progress...
			</div>
		</div>
	);
}

export default withRouter(MeReport);
